import React from 'react'
import { withRouter } from "react-router-dom";
import { Dialog, DialogContent, Button, DialogTitle, TextField, Select, FormControl, InputLabel, MenuItem, DialogActions } from '@material-ui/core';
import TableComponent, { TableOp } from '../../../components/table/TableOps';
import Llegada from './Llegada';
import Http from '../../../Http';
import moment from 'moment';
import ReporteTrafico from './ReporteTrafico';
import MarcarRetraso from './MarcarRetraso';
import { AuthContext } from "../../../context/authContext";
import ACCESS from '../../../ACCESS';
import { STATUS_EMBARQUE } from '../../../helpers/constants';
import Toast from 'react-hot-toast'
import PDFViewer from '../../../components/pdfViewer';

class Embarques extends TableComponent {

  componentDidMount() {
    let acciones = [
      { id: 'edit', icon: 'edit', tooltip: 'Editar', access: [ACCESS.EMBARQUE.EDITAR_EMBARQUES_CREADAS_POR_EL_USUARIO, ACCESS.EMBARQUE.EDITAR_EMBARQUES_SUCURSAL_DEL_USUARIO, ACCESS.EMBARQUE.EDITAR_EMBARQUE_SIN_RESTRICCIONES, ACCESS.EMBARQUE.EDITAR_TODAS_EMBARQUES] },
      { id: 'salida', icon: 'exit_to_app', tooltip: 'Marcar Salida', access: [ACCESS.EMBARQUE.MARCAR_SALIDA_A_EMBARQUES_CREADOS_POR_EL_USUARIO, ACCESS.EMBARQUE.MARCAR_SALIDA_A_TODOS_LOS_EMBARQUES, ACCESS.EMBARQUE.MARCAR_SALIDA_A_EMBARQUES_DE_SUCURSAL_DEL_USUARIO] },
      { id: 'carta_porte', icon: 'description', tooltip: 'Ver Cartas Porte', access: [ACCESS.EMBARQUE.GENERAR_CARTA_PORTE_DEL_EMBARQUE] },
      { id: 'retraso', icon: 'sms_failed', tooltip: 'Marcar Retraso', access: [ACCESS.EMBARQUE.MARCAR_RETRASO_DE_EMBARQUE] },
      { id: 'llegada', icon: 'assignment', tooltip: 'Marcar llegada', access: [ACCESS.EMBARQUE.MARCAR_LLEGADA_A_EMBARQUES_CREADOS_POR_EL_USUARIO, ACCESS.EMBARQUE.MARCAR_LLEGADA_A_TODOS_LOS_EMBARQUES, ACCESS.EMBARQUE.MARCAR_LLEGADA_A_EMBARQUES_DE_SUCURSAL_DEL_USUARIO] },
      { id: 'download', icon: 'download', tooltip: 'Desembarque de Guias', access: [ACCESS.EMBARQUE.DESEMBARQUE_GUIAS] },
      { id: 'reporte', icon: 'picture_as_pdf', tooltip: 'Reporte', access: [ACCESS.EMBARQUE.DESCARGAR_REPORTE_PDF] },
      { id: 'reporte_productos', icon: 'local_shipping', tooltip: 'Reporte Productos', access: [ACCESS.EMBARQUE.DESCARGAR_REPORTE_PRODUCTOS] },
      { id: 'reporte_etiqueta', icon: 'local_shipping', tooltip: 'Reporte Etiquetas/Guias', access: [ACCESS.EMBARQUE.DESCARGAR_REPORTE_DE_ETIQUETAS_Y_GUIAS] },
      { id: 'reporte_desembarque', icon: 'local_shipping', tooltip: 'Reporte Etiquetas Embarque/Desembarque', access: [ACCESS.EMBARQUE.DESCARGAR_REPORTE_DE_ETIQUETAS_EMBARQUE_DESEMBARQUE] },
    ];

    this.tableConfig(
      { dataUrl: 'embarque/filter', deleteUrl: '', deleteField: '', modUrl: '/Guias/Embarque' },
      TableOp.Table('Embarques', [
        { label: 'Folio', id: 'id' },
        { label: 'Estado', id: 'status_description' },
        { label: 'Circuito', id: 'circuito' },
        { label: 'Salida', id: 'salida_fecha' },
        { label: 'Timbrado', id: 'timbrado' },
        { label: 'Tractor', id: 'tractor' },
        { label: 'Caja', id: 'caja' },
        { label: 'Operador', id: 'operador' },
        { label: 'Llegada', id: 'llegada_fecha' },
      ], acciones))
    this.table();
    this.getSucursales();
  }

  getSucursales = async () => {
    let sucursales = [{ id: 0, sucursal: 'Cualquier Sucursal' }];
    const Res = await Http.get('sucursal/all');
    if (!Res.error) {
      sucursales.push(...Res.data)
    }
    this.setState({ sucursales });
  }

  action = (id, row) => {
    let dellOpen = false;
    if (id === 'llegada') {
      if ([STATUS_EMBARQUE.SALIDA_MARCADA].includes(row.status)) {
        dellOpen = true;
      } else {
        Toast.error('No se puede marcar llegada')
      }
    } else if (id === 'edit') {
      this.props.history.push(`/Guias/Embarque/${row.id}`)
    } else if (id === 'salida') {
      if ([STATUS_EMBARQUE.GUIAS_ASIGNADAS, STATUS_EMBARQUE.LLEGADA_SUCURSAL].includes(row.status)) {
        this.props.history.push(`/Guias/Embarque/${row.id}/Salida`)
      } else {
        Toast.error('No se puede marcar salida del embarque')
      }
    } else if (id === "reporte") {
      this.downloadPDFReport(row.id)
    } else if (id === "retraso") {
      let retrasoOpen = true;
      if (row.status !== 3) {
        retrasoOpen = false;
        Toast.error('Primero debe darle salida al embarque')
      }
      this.setState({ dRow: row, retrasoOpen });
    } else if (id === "carta_porte") {
      this.props.history.push(`/Guias/Embarque/${row.id}/CartaPorte`)
      this.setState({ dRow: row });
    } else if (id === "reporte_productos") {
      this.downloadReportProductos(row.id)
    } else if (id === "reporte_etiqueta") {
      this.downloadReportEtiqueta(row.id)
    } else if (id === "reporte_desembarque") {
      this.downloadReportDesembarque(row.id)
    } else if (id === 'download') {
      if (![STATUS_EMBARQUE.FIN_CIRCUITO, STATUS_EMBARQUE.LLEGADA_SUCURSAL].includes(row.status)) {
        Toast.error('No tiene llegada')
      } else {
        this.props.history.push(`/Guias/Embarque/${row.id}/Desembarque`)
      }
    }
    this.setState({ dRow: row, dellOpen });
  }

  downloadPDFReport = async (id) => {
    this.setState({ loading: true });
    const Resp = await Http.get(`embarque/pdf/${id}`, true, 'arraybuffer')
    if (!Resp.error) {
      const blob = new Blob([Resp], { type: 'application/pdf' });
      this.setState({
        pdfURL: URL.createObjectURL(blob),
        viewPdf: true,
        downloadZip: false,
        loading: false
      });
    }
    this.setState({ loading: false });
  }

  downloadReportProductos = async (id) => {
    this.setState({ loadingReport: true, loading: true });
    const Resp = await Http.get(`embarque/productos-reporte?id_embarque=${id}`, true, 'arraybuffer')
    if (!Resp.error) {
      const blob = new Blob([Resp], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
      const a = document.createElement('a');
      const url = URL.createObjectURL(blob)
      a.style.display = 'none';
      a.href = url;
      a.download = `productos_embarque_${id}.xlsx`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      this.setState({ loadingReport: false });
    }
    this.setState({ loading: false });
  }

  downloadReportEtiqueta = async (id) => {
    this.setState({ loadingReport: true, loading: true });
    const Resp = await Http.get(`embarque/etiqueta-reporte?id_embarque=${id}`, true, 'arraybuffer')
    if (!Resp.error) {
      const blob = new Blob([Resp], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
      const a = document.createElement('a');
      const url = URL.createObjectURL(blob)
      a.style.display = 'none';
      a.href = url;
      a.download = `guias_etiquetas_embarque_${id}.xlsx`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      this.setState({ loadingReport: false });
    }
    this.setState({ loading: false });
  }

  downloadReportDesembarque = async (id) => {
    this.setState({ loadingReport: true, loading: true });
    const Resp = await Http.get(`embarque/desembarque-reporte?id_embarque=${id}`, true, 'arraybuffer')
    if (!Resp.error) {
      const blob = new Blob([Resp], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
      const a = document.createElement('a');
      const url = URL.createObjectURL(blob)
      a.style.display = 'none';
      a.href = url;
      a.download = `etiquetas_embarque_${id}.xlsx`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      this.setState({ loadingReport: false });
    }
    this.setState({ loading: false });
  }

  crearEmbarque = () => {
    this.props.history.push(`/Guias/Embarque/Create`)
  }

  guardadoLlegada = (act) => {
    const { dRow } = this.state
    if (act.continue) {
      this.props.history.push(`/Guias/Embarque/${dRow.id}/Desembarque`)
    } else {
      this.setState({ dellOpen: false, dCarta: false, dRow: {} });
    }
  }

  guardadoDesembarque = () => {
    this.setState({ dellOpen: false, dCarta: false, dRow: {}, desGuiaOpen: false });
  }

  guardadoRetraso = (msg) => {
    this.setState({ retrasoOpen: false, dRow: {}, dCarta: false, sbOpen: true, sbMsg: msg });
    this.table();
  }

  downloadReport = () => {
    this.setState({ drOpen: true, startDate: moment().format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD') });
  };

  downloadReport2 = async () => {
    this.setState({ loadingReport: true });
    const { sucursales, startDate, endDate, filter_id_origen = 0, filter_id_destino = 0, } = this.state;
    const origen = sucursales.find(suc => suc.id === filter_id_origen)
    const destino = sucursales.find(suc => suc.id === filter_id_destino)
    const Resp = await Http.get(`embarque/excel-embarque?q=1&startDate=${startDate}&endDate=${endDate}&id_origen=${filter_id_origen}&id_destino=${filter_id_destino}`, true, 'arraybuffer')
    if (!Resp.error) {
      const blob = new Blob([Resp], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
      const a = document.createElement('a');
      const url = URL.createObjectURL(blob)
      a.style.display = 'none';
      a.href = url;
      a.download = `embarques_ruta-${startDate}-${endDate}-${origen.sucursal}-${destino.sucursal}.xlsx`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      this.setState({ loadingReport: false });
    } else {
      this.setState({ sbOpen: true, sbMsg: 'No hay guías', loadingReport: false });
    }
  }

  onDateChange = (value, type) => {
    this.setState({ [type]: value });
  }

  getReporteTrafico = async () => {
    this.setState({ drtOpen: true });
  }

  viewPdfClose = () => {
    this.setState({ viewPdf: false });
  };

  handledownloadPdf = () => {
    const { pdfURL, dRow } = this.state;
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = pdfURL;
    a.download = `embarque_${dRow.id}.pdf`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(pdfURL);
  }

  render() {
    const { dRow, dellOpen = false, drOpen = false, startDate,
      endDate, filter_id_origen = 0, filter_id_destino = 0, sucursales,
      drtOpen = false, loadingReport = false, retrasoOpen = false, viewPdf = false, pdfURL, downloadZip } = this.state;
    const { hasAccess } = this.context;
    return (
      <div>
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            {hasAccess([ACCESS.EMBARQUE.DESCARGAR_REPORTE_DE_EMBARQUE_X_RUTA]) &&
              <Button variant='contained' color='primary' onClick={this.downloadReport}>Descargar Embarque x Ruta</Button>
            }
            {hasAccess([ACCESS.EMBARQUE.DESCARGAR_REPORTE_DE_TRAFICO]) &&
              <Button variant='contained' color='secondary' onClick={this.getReporteTrafico}>Reporte de tráfico</Button>
            }
            {hasAccess([ACCESS.EMBARQUE.CREAR_EMBARQUE]) &&
              <Button variant='contained' color='primary' onClick={this.crearEmbarque}>Crear embarque</Button>
            }
          </div>
          <this.TableRender />
        </div>

        {/** Modal llegada embarques */}
        <div>
          <Dialog
            open={dellOpen ? dellOpen : false}
            onClose={() => this.setState({ dellOpen: false, dRow: {} })}
            maxWidth='lg'
            fullWidth
          >
            <DialogContent>
              <Llegada
                id={dRow ? dRow.id : null}
                onSave={(act) => { this.guardadoLlegada(act) }}
                sucursales={this.state.sucursales}
                id_sucursal={this.context.user.id_sucursal}
              />
            </DialogContent>
          </Dialog>
        </div>

        {/** Modal retrso de embarques */}
        <div>
          <Dialog
            open={retrasoOpen ? retrasoOpen : false}
            onClose={() => this.setState({ retrasoOpen: false, dRow: {} })}
          >
            <DialogTitle>
              Retraso en embarque #{dRow ? dRow.id : null}
            </DialogTitle>
            <DialogContent>
              <MarcarRetraso id={dRow ? dRow.id : null} onSave={this.guardadoRetraso} />
            </DialogContent>
          </Dialog>
        </div>

        {/** Modal reporte de trafico */}
        <div>
          <Dialog
            open={drtOpen ? drtOpen : false}
            onClose={() => this.setState({ drtOpen: false })}
          >
            <DialogContent>
              <ReporteTrafico />
            </DialogContent>
          </Dialog>
        </div>

        {/** Modal reporte embarque x ruta */}
        <div>
          <Dialog
            open={drOpen ? drOpen : false}
            onClose={() => this.setState({ drOpen: false })}
          >
            <DialogContent>
              <div className="row" >
                <div className="col-sm-6">
                  <TextField
                    onChange={(e) => this.onDateChange(e.target.value, 'startDate')}
                    value={startDate}
                    type={'date'} label='Desde' variant="outlined" className="form-field" />
                </div>
                <div className="col-sm-6">
                  <TextField
                    onChange={(e) => this.onDateChange(e.target.value, 'endDate')}
                    value={endDate}
                    type={'date'} label='Hasta' variant="outlined" className="form-field" />
                </div>
                <div className="col-sm-6">
                  {sucursales && <FormControl variant="outlined" className='form-field'>
                    <InputLabel>Sucursal Origen</InputLabel>
                    <Select
                      value={filter_id_origen}
                      onChange={(e) => this.onDateChange(e.target.value, 'filter_id_origen')}
                    >
                      {sucursales.map((option, i) => {
                        return (<MenuItem value={option.id} key={i}>{option.sucursal}</MenuItem>)
                      })}
                    </Select>
                  </FormControl>}
                </div>
                <div className="col-sm-6">
                  {sucursales && <FormControl variant="outlined" className='form-field'>
                    <InputLabel>Sucursal Destino</InputLabel>
                    <Select
                      value={filter_id_destino}
                      onChange={(e) => this.onDateChange(e.target.value, 'filter_id_destino')}
                    >
                      {sucursales.map((option, i) => {
                        return (<MenuItem value={option.id} key={i}>{option.sucursal}</MenuItem>)
                      })}
                    </Select>
                  </FormControl>}
                </div>
                <div className="col-sm-12" style={{ display: 'flex', justifyContent: 'space-between' }} >
                  <Button variant='contained' color='primary' onClick={() => this.setState({ drOpen: false })}>
                    Cerrar
                  </Button>
                  <Button variant='contained' onClick={this.downloadReport2} disabled={loadingReport}>
                    Descargar
                  </Button>
                </div>
              </div>
            </DialogContent>
          </Dialog>
        </div>

        {/* Modal visualizar impresion */}
        <Dialog
          onClose={this.viewPdfClose}
          open={viewPdf || false}
          fullWidth={true}
          maxWidth={"md"}
        >
          <DialogTitle onClose={this.viewPdfClose}>Vista Previa</DialogTitle>
          <DialogContent dividers>
            {pdfURL !== "" && (
              <div className="pdf-viewer">
                <PDFViewer
                  alert={err => (
                    <div
                      style={{
                        color: '#fa5b35',
                      }}>
                      <h6>No hay guías en el embarque</h6>
                    </div>
                  )}
                  scale={1}
                  style={{ height: 400 }}
                  document={{
                    url: pdfURL,
                  }}
                  pdfUrl={pdfURL}
                />
              </div>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.viewPdfClose}>Cancelar</Button>
            <Button
              variant="contained"
              onClick={this.handledownloadPdf}
            >
              Descargar Pdf
            </Button>
            {downloadZip &&
              <Button
                variant="contained"
                onClick={this.handledownloaZip}
              >
                Descargar zip
              </Button>
            }
          </DialogActions>
        </Dialog>

      </div>
    )
  }
}

Embarques.contextType = AuthContext;
export default withRouter(Embarques)